export const data = [
  {
    id: "780-850",
    renters: "20",
    color: "#B8B8F8",
    data: [
      {
        x: "0",
        y: "792"
      },
      {
        x: "1",
        y: "800"
      },
      {
        x: "2",
        y: "805"
      },
      {
        x: "3",
        y: "810"
      },
      {
        x: "4",
        y: "812"
      },
      {
        x: "5",
        y: "820"
      },
      {
        x: "6",
        y: "825"
      }
    ]
  },
  {
    id: "660-779",
    renters: "89",
    color: "#4646DC",
    data: [
      {
        x: "0",
        y: "673"
      },
      {
        x: "1",
        y: "680"
      },
      {
        x: "2",
        y: "683"
      },
      {
        x: "3",
        y: "689"
      },
      {
        x: "4",
        y: "700"
      },
      {
        x: "5",
        y: "705"
      },
      {
        x: "6",
        y: "710"
      }
    ]
  },
  {
    id: "600-659",
    renters: "346",
    color: "#3C3CAA",
    data: [
      {
        x: "0",
        y: "604"
      },
      {
        x: "1",
        y: "610"
      },
      {
        x: "2",
        y: "632"
      },
      {
        x: "3",
        y: "644"
      },
      {
        x: "4",
        y: "650"
      },
      {
        x: "5",
        y: "667"
      },
      {
        x: "6",
        y: "669"
      }
    ]
  },
  {
    id: "500-599",
    renters: "254",
    color: "#E6007E",
    data: [
      {
        x: "0",
        y: "514"
      },
      {
        x: "1",
        y: "550"
      },
      {
        x: "2",
        y: "570"
      },
      {
        x: "3",
        y: "580"
      },
      {
        x: "4",
        y: "600"
      },
      {
        x: "5",
        y: "610"
      },
      {
        x: "6",
        y: "615"
      }
    ]
  },
  {
    id: "300-499",
    renters: "125",
    color: "#B70064",
    data: [
      {
        x: "0",
        y: "310"
      },
      {
        x: "1",
        y: "340"
      },
      {
        x: "2",
        y: "400"
      },
      {
        x: "3",
        y: "420"
      },
      {
        x: "4",
        y: "500"
      },
      {
        x: "5",
        y: "520"
      },
      {
        x: "6",
        y: "540"
      }
    ]
  }
];

export const sampleData = [
  {
    title: "Credit score change",
    content: "+72pts",
    tooltip: "lorem ipsum",
    subContent: "550(starting) > 622(ending)"
  },
  {
    title: "Renters with improved credit",
    content: "47.8%",
    tooltip: "lorem ipsum",
    subContent: "428 of 834 enrollments"
  },
  {
    title: "Cumulative credit points added",
    content: "+1387pts",
    tooltip: "lorem ipsum",
    subContent: ""
  },
  {
    title: "Enrollments",
    content: "834",
    tooltip: "lorem ipsum",
    subContent: ""
  },
  {
    title: "Credit scores established",
    content: "233",
    tooltip: "lorem ipsum",
    subContent: ""
  },
  {
    title: "Prime credit scores established",
    content: "28",
    tooltip: "lorem ipsum",
    subContent: ""
  }
];

export const tableData = [
  ...[...data].reverse().map((d) => {
    return {
      startingScore: d.id,
      renters: d.renters,
      initialCreditScore: d.data[0].y,
      "1 month": d.data[1].y,
      "2 months": d.data[2].y,
      "3 months": d.data[3].y,
      "4 months": d.data[4].y,
      "5 months": d.data[5].y,
      "6 months": d.data[6].y
    };
  }),
  {
    startingScore: "300-850",
    renters: "834",
    initialCreditScore: "610",
    "1 month": "625",
    "2 months": "644",
    "3 months": "671",
    "4 months": "683",
    "5 months": "696",
    "6 months": "705"
  }
];
